import { IApplicationState } from 'shared/types/redux';

export const selectIsTermsModalOpen = (state: IApplicationState) => state.landing.isTermsModalOpen;

export const selectTermsModalData = (state: IApplicationState) => state.landing.termsModalData;
